export default "__VITE_ASSET__90803110__"